import React from 'react';
import { Container, Row, Col, Card, CardBody, ListGroup, ListGroupItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faGavel, faDownload } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import doc1 from '../../assets/Notifications 2015 Qualification of Clerk.pdf'
import doc2 from '../../assets/SETC exemted before 7.11.2013 notification.pdf'
import doc3 from '../../assets/Ommission of Assistant Secretary Zila Sainik Board.pdf'
import doc4 from '../../assets/Service Rule Group C (Dated 24.05.1999).pdf'
import doc5 from '../../assets/Service Rule Group D (Dated 31.10.2003).pdf'
import doc6 from '../../assets/Service Rules Group A 24.05.1999.pdf'

const rulesData = [
  { title: 'Haryana Defence Services Welfare Department State (Group A) Service Rules, 1999', link:doc6},
  { title: 'Haryana Defence Services Welfare Department Field Staff (Group C) Service Rules, 1999',link:doc4},
  { title: 'Haryana Defence Services Welfare Department Field Staff (Group D) Service Rules, 2003',link:doc5 },
  { title: 'Notifications 2015 Qualification of Clerk',link:doc1 },
  { title: 'SETC exemted before 7.11.2013 notification',link:doc2 },
  { title: 'Ommission of Assistant Secretary Zila Sainik Board',link:doc3 },
];

const ActsRules = () => {
  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faGavel} className="me-2" />
            Acts & Rules
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <Row>
          <Col lg={12}>
            <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
              <div style={{
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                padding: '25px',
                color: 'white'
              }}>
                <h4 className="fw-bold mb-0">
                  <FontAwesomeIcon icon={faGavel} className="me-2" />
                  Service Rules & Notifications
                </h4>
              </div>
              <CardBody className="p-4">
                <ListGroup flush>
                  {rulesData.map((rule, index) => (
                    <ListGroupItem 
                      key={index} 
                      className="py-3 px-0 border-bottom"
                      style={{ borderColor: '#e9ecef' }}
                    >
                      <a 
                        href={rule.link} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}
                      >
                        <div style={{
                          background: 'rgba(30,60,114,0.1)',
                          color: '#1e3c72',
                          padding: '10px 15px',
                          borderRadius: '8px',
                          marginRight: '15px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          minWidth: '30px',
                          fontWeight: '600'
                        }}>
                          {index + 1}
                        </div>
                        <div className="flex-grow-1">
                          <strong style={{ color: '#1e3c72', fontSize: '1rem' }}>{rule.title}</strong>
                        </div>
                        <div style={{
                          background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                          color: 'white',
                          padding: '8px 20px',
                          borderRadius: '20px',
                          fontSize: '0.85rem',
                          fontWeight: '600',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}>
                          <FontAwesomeIcon icon={faDownload} />
                          View
                        </div>
                      </a>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ActsRules;

